import React, {memo} from "../../../__snowpack__/pkg/react.js";
import {Tooltip} from "../../../__snowpack__/pkg/antd.js";
import styled from "../../../__snowpack__/pkg/styled-components.js";
export const NameWrapper = styled.span`
  font-size: 12px;
  font-family: 'SFProText-Regular';
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  word-break: break-all;
  color: ${(props) => props.color};
  max-width: ${(props) => props.width + "px"};
  -webkit-line-clamp: ${(props) => props.line};
  -webkit-box-orient: vertical;
`;
export const EllipsisShowTooltip = memo((props) => {
  const {title, children, style = {}, width = 200, line = 2, color = "#202D40"} = props;
  return /* @__PURE__ */ React.createElement(Tooltip, {
    title: ["-", "\u2014\u2014", null, void 0].includes(title) ? "" : title
  }, /* @__PURE__ */ React.createElement(NameWrapper, {
    line,
    width,
    color,
    style
  }, children || title));
});
